import { createSlice } from "@reduxjs/toolkit";

// required:  define initial state for cart module
export const customerInitialState = {
    customer: {}
}

// required:  create slice for cart module with required reducers (actions)
export const customerSlice = createSlice({
    name: "customer",
    initialState: customerInitialState,
    reducers: {
        storeCustomer: (state, action) => {
            state.customer = action.payload;
        },
        clearCustomer: (state,action)=>{
            state.customer = {}
        }
    },
});

// required: export all defined reducer functions as actions
export const {
    storeCustomer,
    clearCustomer
} = customerSlice.actions;

// required: export complete reducer
export default customerSlice.reducer;